// extracted by mini-css-extract-plugin
module.exports = {"dishModificationList":"_9ik9IXvk8732bAR6MuVyI","additionalContent":"_2Z7x6Gp3fpA1GqhnFmntaZ","showInCombo":"_3jjQhkOtfj8a0eI3gfkTq6","externalId":"_1zelmpAcJNR3MTwkf3Az_x"};